module.exports = "/images/duplication.svg?dca9e824c3d76ab35b53fb4464d3a5c0";